import {
  IntegrationsSchema,
  addressTypeSchema,
} from "@redotech/redo-model/address-collection";
import * as z from "zod/v4";

export const getOrCreateExternalAddress = {
  name: "getOrCreateExternalAddress" as const,
  input: z.object({
    provider: addressTypeSchema,
    externalId: z.string(),
    integrations: IntegrationsSchema.optional(),
  }),
  output: z.object({ addressId: z.string() }),
};
